import type { AuthConfig, IdTokenProfile } from '../types/types'
import { IdTokenData } from '../types/tokenTypes'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

// Server side only: pages pass the result to the browser, which cannot read the id token.
export default (config: AuthConfig, cookieHeader?: string) => {
  const token = tokenHandler(config)
  const cookies = cookieHandler(cookieHeader)

  return (): IdTokenProfile | null => {
    if (typeof window !== 'undefined') return null

    const idToken = token.getValidToken<IdTokenData>(cookies.getIdToken())

    return idToken ? token.getIdTokenProfile(idToken) : null
  }
}
